import { useContext } from 'react'
import HppContext from 'common/contexts/hpp'

function useHppContext(): HPPSettings {
  return useContext(HppContext)
}

export default useHppContext
